import {BaseStore, IBaseStore} from "./base-store";
import {IDataset} from "../components/dataset/IDataset";
import {ISupplier, supplierColumns} from "../models/Supplier";
import {action, computed, observable, runInAction} from "mobx";
import {IRootStore} from "../routes/root-store";
import {RouterState} from "mobx-state-router";
import {IProject, projectColumns} from "../models/Project";
import {Dataset} from "../components/dataset/dataset";
import axios from "axios";
import {IUser, userColumns} from "../models/User";
import {includes} from "../components/lib/Includes";
import * as R from 'ramda';


export interface ISupplierStore extends IBaseStore<ISupplier> {
    ds: IDataset<ISupplier>;
    dsProject: IDataset<IProject>;
    uploadLogo: (acceptFile: any[]) => Promise<void>;
    uploadIcon: (acceptFile: any[]) => Promise<void>;
    logoUrl: string;
    iconUrl: string;
    dsUser: IDataset<IUser>;
}


export class SupplierStore extends BaseStore<ISupplier> implements ISupplierStore {

    @observable
    dsProject: IDataset<IProject>;

    @observable
    dsUser: IDataset<IUser>;

    constructor(rootStore: IRootStore) {
        super(rootStore, '/gridApi/supplier/', supplierColumns);
        //
        this.dsProject = new Dataset<IProject>('/gridApi/project/', projectColumns);
        this.dsProject.setMasterSource(this.ds, [{field: 'supplierno', masterField: 'supplierno'}]);

        this.dsUser = new Dataset<IUser>('/gridApi/user/', R.clone(userColumns).map(column => {
                if (includes(['supplierno', 'supplier1', 'customerno', 'customer1'], column.fieldName)) {
                    column.hide = 'table';
                }
                return column
            }
        ));
        this.dsUser.setMasterSource(this.ds, [{field: 'supplierno', masterField: 'supplierno'}]);
    }

    @action.bound
    async openDetails() {
        await this.dsProject.open();
        await this.dsUser.open();
    }

    @action.bound
    closeDetails() {
        this.dsUser.close();
        this.dsProject.close();
    }


    @action.bound
    async onEnter(fromState: RouterState, toState: RouterState) {
        if (toState.routeName === 'suppliertable') {
            await this.open();
            if (fromState.routeName === 'catalog') {
                this.ds.locate(this.ds.pkFields, fromState.params)
            }
        } else if (toState.routeName === 'supplier') {
            await this.open(toState.params as any);
            await this.openDetails();
        }
    }

    @action.bound
    async onExit(fromState: RouterState, toState: RouterState) {
        if (fromState.routeName === 'supplier') {
            /*            if (this.rootStore.authStore.username !== '') {
                            await this.ds.post();
                        }*/
            this.closeDetails();
            this.close();
            await Promise.resolve();
        } else if (fromState.routeName === 'suppliertable') {
            this.close();
            await Promise.resolve();
        }
    }

    @action.bound
    async uploadLogo(acceptFile: any[]): Promise<void> {
        const url = '/gridApi/supplierlogo/upload';
        const file = acceptFile[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('supplierno', this.ds.actual.supplierno);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        await axios.post(url, formData, config);
        runInAction(async () => {
            this.ds.actual.logo = file.name;
        });
    }

    @action.bound
    async uploadIcon(acceptFile: any[]): Promise<void> {
        const url = '/gridApi/suppliericon/upload';
        const file = acceptFile[0];
        console.log(file)
        const formData = new FormData();
        formData.append('file', file);
        formData.append('supplierno', this.ds.actual.supplierno);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        await axios.post(url, formData, config);
        runInAction(async () => {
            this.ds.actual.icon = file.name;
        });

    }

    @computed
    get logoUrl() {
        if (this.ds.actual?.logo) {
            return "/gridApi/supplierlogo/download/" + this.ds.actual?.supplierno + "/" + this.ds.actual?.logo;
        } else return ""
    }

    @computed
    get iconUrl() {
        if (this.ds.actual?.icon) {
            return "/gridApi/suppliericon/download/" + this.ds.actual?.supplierno + "/" + this.ds.actual?.icon;
        } else return ""
    }

}
